export class ProductGroupDetails {
    code: string;
    name: string;
    description: string;
    category: object;
    domain: string;
}


// WEBPACK FOOTER //
// ./src/app/agora/components/product-data/product-groups/details/product-group-details.model.ts